<template>
    <div>    
      <div class="row">
            <div class="col-md-12" style="margin-top: -40px; height: 200px;">
                <graficohalfdoughnut    :rotulo="'DETALHES:'"
                                        :legendas="legendasmetavendedorpadrao"
                                        :dados="dadosmetavendedorpadrao"
                ></graficohalfdoughnut>
            </div>
        </div>
    </div>
</template>

<script>
import util from '../../utilitarios/util';
import GraficoHalfDoughnut from '../../components/cmpgraficohalfdonut.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficohalfdoughnut'   : GraficoHalfDoughnut,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasmetavendedorpadrao : [],
        dadosmetavendedorpadrao    : [],
       
        isloading                  : false,  
        usuariologado              : this.$store.state.usuario,
    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
  ],
  methods:{
        mtdvendedorpadraoinfo() {
            var vself = this;
            vself.$emit('handlerLoader', true);
            let parametros = [
                {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},                    
                {parametro: 'op',           valor : 'vendedorpadraometa'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'dtinicio',     valor : vself.pdtini},
                {parametro: 'dtfim',        valor : vself.pdtfim},
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                //Funções a serem feitas quando a requisição for bem sucedida
                let vendedorMeta          = response.data[0];
                let vendedorMetaAtingida  = response.data[1];
                let vendedorMetaRestante  = vendedorMeta - vendedorMetaAtingida;


                if (vendedorMetaRestante < 0) {
                    vendedorMetaRestante = 0;
                }
                vself.dadosmetavendedorpadrao = [
                    {value: parseFloat(vendedorMetaAtingida)    , name: 'ATINGIDA'},
                    {value: parseFloat(vendedorMetaRestante)    , name: 'RESTANTE'}
                ];
                vself.legendasmetavendedorpadrao = util.gerardadoslegendagrafico(vself.legendasmetavendedorpadrao);
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.$emit('handlerLoader', false);
            });  
        },
        mtdformatavalordecimal(valor){
			return util.formatarvalor(valor, '');
        }, 
  },
  mounted(){
    setTimeout(() => {
         this.mtdvendedorpadraoinfo();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
